import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Availability() {
    return (
        <OnboardingBody title='Availability made simple'>
            <p>Scheduler handles your availability, so you can focus on what matters.</p>
            <BulletedList
                bullets={[
                    <span key='1'>
                        Automatically syncs with your calendar to dictate available time slots
                    </span>,
                    <span key='2'>
                        Customize per-meeting availability, start times, and buffer times for
                        precision scheduling
                    </span>,
                ]}
            />
        </OnboardingBody>
    );
}
